define('customersDetailBodyDocumentsView',[
  'app',
  'module',
  'underscore',
  'attachmentsView'
], function(
  App,
  Module,
  _,
  AttachmentsView
) {
  'use strict';

  Module.exports = AttachmentsView.extend({
    className: 'customers-detail-documents-view attachments-view',
    setConfig() {
      return {
        galleryTitle: 'Customer Documents',
        canCopy: false
      };
    },

    fetch: function(first, pageSize) {
      return this.model.getDocuments(first, pageSize);
    },

    uploadItem: function(file) {
      return this.model.uploadDocument(file);
    },

    deleteItem(attachment) {
      return this.model.deleteDocument(attachment);
    },

    editItem: function(attachment) {
      App.navigate('attachments/attachments/' + this.model.get('secId') + '/' + attachment.get('secId') + '/customer', {trigger: true});
    }
  });
});

